wbApp.controller('GalleryInfoEditDialogCtrl', ['$scope', 'protectedStorageSvc', 'securitySvc',
function ($scope, protectedStorageSvc, securitySvc) {

    $scope.isSaving = false;
    $scope.galleryDirectory = $scope.galleryDirectory || "";
    $scope.modelOrig = angular.copy($scope.model);
    $scope.images = [];

    $scope.detailIsUnchanged = function (data) {
        return angular.equals(data, $scope.modelOrig);
    };

    $scope.detailGalleryEditTabs = [{
        title: 'TXT_MAIN',
        template: "activities/gallery-info-edit-dlg-main-tab.html"
    }];
    if (securitySvc.isInRole('ProtectedStorage')) {
        $scope.detailGalleryEditTabs.push({
            title: 'TXT_LBL_PICTURES',
            template: "activities/gallery-info-edit-dlg-pictures-tab.html"
        });
    }

    $scope.detailGalleryEditTabs.activeTab = 0;

    $scope.$watch('detailGalleryEditTabs.activeTab', function (newValue, oldValue) {
        switch (newValue) {
            case 1:
                loadPictures();
                break;
        }
    });
    
    function getFileNameFromUrl(signedUri) {
        if (!signedUri || signedUri.trim() === "") {
            return signedUri;
        }

        const paramIndex = signedUri.indexOf("?");
        return paramIndex === -1
            ? signedUri.substring(signedUri.lastIndexOf("/") + 1)
            : signedUri.substring(signedUri.lastIndexOf("/") + 1, paramIndex);
    }
    
    function loadPictures() {
        protectedStorageSvc.findGalleryInfoByPaths([$scope.galleryDirectory], true)
            .$promise.then(function(data) {
            $scope.images.length = 0;
            $scope.images.push.apply($scope.images,data[0].images);
            for (let i = 0; i < $scope.images.length; i++) {
                let image = $scope.images[i];
                if (image.imageUrl) {
                    image.name = getFileNameFromUrl(image.imageUrl);
                }
            }
        }, function error() {
                
        });
    }
    
    $scope.markImage = function(image) {
        $scope.model.headerImageName = getFileNameFromUrl(image.imageUrl);
    }

    $scope.onDetailSave = function (model) {

        if ($scope.isSaving) {
            return;
        }

        $scope.isSaving = true;


        protectedStorageSvc.updateGalleryInfo(model, $scope.galleryDirectory)
            .$promise.then(function () {
                $scope.isSaving = false;
                $scope.$hide();
                if ($scope.onGalleryInfoSave) {
                    $scope.onGalleryInfoSave(model);
                }
            }, function (data) {
                $scope.isSaving = false;
                $scope.detailError = data;
            });
    }

}]);
